export default __webpack_public_path__ + "static/media/DSC00409.5c201e32.JPG";